
export const combine_text: (input: string[], practice: string[]) => string[][] = (input: string[], practice: string[]) => {
    let output: string[][] = [[], [], practice]

    let index = 0
    while (index < input.length) {
      if (input[index] !== practice[index])
        break;
      index++;
    }
    output = [
      practice.slice(0, index),
      practice.slice(index, Math.min(input.length, practice.length)),
      practice.slice(Math.min(input.length, practice.length), practice.length)
    ]
    
    return output
  }